import React from 'react'
import Slides from '../slides/Slides'
import ContratosArt from './ContratosArt'
import iconContactoMasculino from "../../img/iconContactoMasculino.jpg";
import iconContactoFemenino from "../../img/iconContactoFemenino.jpg";
import SiniestrosLaborales from './SiniestrosLaborales';
import SiniestroAutomotor from './SiniestroAutomotor';
import Prevencion from './Prevencion';
import Dinerarias from './Dinerarias';
import Granizo from './Granizo';
import AsistenciaTecnica from './AsistenciaTecnica';
import Sucursales from './Sucursales';
import Footer from '../footer/Footer';

const Contacto = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"contacto"}/>
         <div className="container animated fadeIn">
            <div className="section">
               <ContratosArt iconContactoMasculino={iconContactoMasculino}/>
               <SiniestrosLaborales iconContactoMasculino={iconContactoMasculino}/>
               <SiniestroAutomotor iconContactoMasculino={iconContactoMasculino}/>
               <Prevencion iconContactoMasculino={iconContactoMasculino}/>
               <Dinerarias iconContactoMasculino={iconContactoMasculino} iconContactoFemenino={iconContactoFemenino}/>
               <Granizo iconContactoMasculino={iconContactoMasculino}/>
               <AsistenciaTecnica iconContactoMasculino={iconContactoMasculino}/>
               <Sucursales/>
            </div>
         </div>
      </>
   )
}

export default Contacto